import { EditionLayerAttr } from "./edition-layer-attr";
import { EditionLayerStyles } from "./edition-layer-styles";

export class EditionLayer {
  public atributs: Array<EditionLayerAttr> = [];
  public capes: string;
  public geometria_camp: string;
  public geometria_tipus: string;
  public namespace: string;
  public prefix: string;
  public thumbnail: string;
  public url: string;
  public nom_capa: string;
  public base_url_imatges: string;
  public carpeta_imatges: string;
  public nom_camp_etiqueta: string = ""
  public estils: Array<EditionLayerStyles>=[];
  public max_features?: number;
  public user_id: string[] = [];
  public cql_filter: string = "";
  public list_view_title_field = '';

  public isVisible(currentUserId: string){
    return this.user_id.indexOf(currentUserId) >= 0 || this.user_id.length === 0
  }

  public getTextStyle(): Array<EditionLayerStyles>{
    return this.estils.filter((value)=>{
      return value.hasTextStyle();
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/models/edition-layer.ts